// @flow

import styled from "@emotion/styled";

import { ChecklistSettings } from "src/styles/checklist";

export const FormSettings = styled(ChecklistSettings)`
  min-width: 258px;
`;
